import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import NavbarVertical from "../components/navbar/vertical/NavbarVertical";
import NavbarTop from "../components/navbar/top/NavbarTop";
import Footer from "../components/footer/Footer";
import classNames from "classnames";

const MainLayout: React.FC = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes("kanban");

  const { user } = useContext(AppContext);
  const navigate = useNavigate();

  const {
    config: { isFluid, navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, [hash]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!user?.isUserLoggedIn) {
    return <Navigate to="/auth/login" />;
  }
  return (
    <div className={"container-fluid"}>
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      <div className={classNames("content", { "pb-0": isKanban })}>
        <NavbarTop />
        <Outlet />
        {!isKanban && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;
